import * as React from "react";
import {
  BlockContext,
  FormBlockDef,
  FormBlockItem,
} from "src/components/FormWithBlocks";
import { DrawItems } from "src/components/DrawItems";
import { ZUid } from "src/types/zUid";
import { blockTitle } from "../blockBuilder/blockTitle";
import styles from "./EntityGroupBlock.module.less";
import { EntityGroupInnerBlock } from "./EntityGroupInnerBlock";

interface PropsEntityGroupBlock {
  title: string;
  prevId: ZUid;
  ctx: BlockContext;
  items: (FormBlockItem | undefined)[];
  subBlocks: (FormBlockDef | undefined)[];
  id: ZUid;
}

export const EntityGroupBlock: React.FC<PropsEntityGroupBlock> = (props) => {
  const { title, prevId, ctx, items, subBlocks, id } = props;
  const itemsCount = items.filter((item) => !!item).length;
  return (
    <div className={styles.box} id={String(id)}>
      {itemsCount > 0 && (
        <EntityGroupInnerBlock title={blockTitle(title)}>
          <DrawItems items={items} ctx={ctx} />
        </EntityGroupInnerBlock>
      )}
      {subBlocks.map((block) =>
        block ? (
          <React.Fragment key={block.key}>
            {block.render(prevId, ctx)}
          </React.Fragment>
        ) : null,
      )}
    </div>
  );
};
